var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/Notifications/NotificationEvent.ts";
import * as t from 'io-ts';
import { Id } from '../Id';
import { Version } from '../Version';
import { BaseClassifier } from '../BaseClassifierRepo';
import { BimReference } from '../BimReference';
import { AssemblyClassifier, DynamicBaseGroup, UserClassifier, UserClassifierGroup, UserClassifierPriorityOrder, UserClassifierRepository, UserClassifierRepositoryFolder } from '../UserClassifierRepo';
import { BimFile } from '../ModelRepo';
import { BimModel } from '../BimEntity';
import { BimElementReferenceItems } from '../BimElementReferenceItems';
import { SubscriptionEvent } from './subscriptions';
export var NotificationEvent;

(function (_NotificationEvent) {
  var Create;

  (function (_Create) {
    var Payload;

    (function (_Payload) {
      var io = _Payload.io = t.union([UserClassifierRepositoryFolder.io, UserClassifier.io, UserClassifierGroup.io, BimReference.io, AssemblyClassifier.io, BimElementReferenceItems.io]);
    })(Payload || (Payload = _Create.Payload || (_Create.Payload = {})));

    var io = _Create.io = t.type({
      type: t.literal('CreateEvent'),
      payload: Payload.io
    }, 'NotificationCreateEvent');

    var is = _Create.is = function (e) {
      return e.type === 'CreateEvent';
    };
  })(Create || (Create = _NotificationEvent.Create || (_NotificationEvent.Create = {})));

  var Update;

  (function (_Update) {
    var Payload;

    (function (_Payload2) {
      var io = _Payload2.io = t.union([BaseClassifier.io, UserClassifierRepositoryFolder.io, UserClassifier.io, UserClassifierGroup.io, BimReference.io, UserClassifierRepository.io, BimFile.ioBuilder(t.literal(BimFile.ModelRepositoryBimFileType)), BimFile.ioBuilder(t.literal(BimFile.BimFileType)), BimModel.ioBuilder(BimFile.Status.io), DynamicBaseGroup.io, AssemblyClassifier.io, UserClassifierPriorityOrder.Response]);
    })(Payload || (Payload = _Update.Payload || (_Update.Payload = {})));

    var io = _Update.io = t.type({
      type: t.literal('UpdateEvent'),
      payload: Payload.io
    }, 'NotificationUpdateEvent');

    var is = _Update.is = function (e) {
      return e.type === 'UpdateEvent';
    };
  })(Update || (Update = _NotificationEvent.Update || (_NotificationEvent.Update = {})));

  var Remove;

  (function (_Remove) {
    var Payload;

    (function (_Payload3) {
      var io = _Payload3.io = t.union([UserClassifierRepository.io, UserClassifierRepositoryFolder.io, UserClassifier.io, UserClassifierGroup.io, BimReference.io, AssemblyClassifier.io]);
    })(Payload || (Payload = _Remove.Payload || (_Remove.Payload = {})));

    var io = _Remove.io = t.type({
      type: t.literal('RemoveEvent'),
      payload: Payload.io
    }, 'NotificationRemoveEvent');

    var is = _Remove.is = function (e) {
      return e.type === 'RemoveEvent';
    };
  })(Remove || (Remove = _NotificationEvent.Remove || (_NotificationEvent.Remove = {})));

  var InclusionStatusChange;

  (function (_InclusionStatusChange) {
    var Payload;

    (function (_Payload4) {
      var io = _Payload4.io = t.type({
        classifierId: Id,
        classifierVersion: Version
      });
    })(Payload || (Payload = _InclusionStatusChange.Payload || (_InclusionStatusChange.Payload = {})));

    var io = _InclusionStatusChange.io = t.type({
      type: t.literal('InclusionStatusChangeEvent'),
      payload: Payload.io
    }, 'InclusionStatusChangeEvent');

    var is = _InclusionStatusChange.is = function (e) {
      return e.type === 'InclusionStatusChangeEvent';
    };
  })(InclusionStatusChange || (InclusionStatusChange = _NotificationEvent.InclusionStatusChange || (_NotificationEvent.InclusionStatusChange = {})));

  var LockStatusChange;

  (function (_LockStatusChange) {
    var Payload;

    (function (_Payload5) {
      var io = _Payload5.io = t.type({
        id: Id,
        isLocked: t["boolean"],
        type: t.string
      });
    })(Payload || (Payload = _LockStatusChange.Payload || (_LockStatusChange.Payload = {})));

    var io = _LockStatusChange.io = t.type({
      type: t.literal('LockStatusEvent'),
      payload: Payload.io
    }, 'LockStatusEvent');

    var is = _LockStatusChange.is = function (e) {
      return e.type === 'LockStatusEvent';
    };
  })(LockStatusChange || (LockStatusChange = _NotificationEvent.LockStatusChange || (_NotificationEvent.LockStatusChange = {})));

  var AssemblyStatusChange;

  (function (_AssemblyStatusChange) {
    var Payload;

    (function (_Payload6) {
      var io = _Payload6.io = AssemblyClassifier.AssemblyStatusChangeEvent;
    })(Payload || (Payload = _AssemblyStatusChange.Payload || (_AssemblyStatusChange.Payload = {})));

    var io = _AssemblyStatusChange.io = t.type({
      type: t.literal('AssemblyStatusChangeEvent'),
      payload: Payload.io
    }, 'AssemblyStatusChangeEvent');

    var is = _AssemblyStatusChange.is = function (e) {
      return e.type === 'AssemblyStatusChangeEvent';
    };
  })(AssemblyStatusChange || (AssemblyStatusChange = _NotificationEvent.AssemblyStatusChange || (_NotificationEvent.AssemblyStatusChange = {})));

  var io = _NotificationEvent.io = t.union([Create.io, Update.io, Remove.io, InclusionStatusChange.io, LockStatusChange.io, AssemblyStatusChange.io, SubscriptionEvent.Unsubscribe.io, SubscriptionEvent.Subscribe.io], 'NotificationEvent');

  var is = _NotificationEvent.is = function (e) {
    return e.type === 'AssemblyStatusChangeEvent' || e.type === 'CreateEvent' || e.type === 'RemoveEvent' || e.type === 'InclusionStatusChangeEvent' || e.type === 'LockStatusEvent' || e.type === 'SubscribeEvent' || e.type === 'UnsubscribeEvent' || e.type === 'UpdateEvent';
  };
})(NotificationEvent || (NotificationEvent = {}));